export enum OcbLocalAgentCommandTarget {
    LocalAgent = 0,
    LocalAgentManager = 1,
}
